import "./supplemental-prototype.mjs";

import { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import App from "./layout/App/App";
import ScrollToTop from "util/ScrollToTop";

import { theme, GlobalStyle } from "layout";
import { SiteSettingsProvider } from "./context/SiteSettingsContext/context";
import { AuthContextProvider } from "context/AuthContext";
import { VwoContextProvider } from "context/VwoContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssVariableProvider } from "@ubnt/ui-components/ThemeContext";

  console.log(__CHECK_INFO__.check);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const queryClient = new QueryClient();

const loadDOM = () => (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <CssVariableProvider useLegacyFont={true}>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop>
          <SiteSettingsProvider>
            <AuthContextProvider>
              <VwoContextProvider>
                <ThemeProvider theme={theme}>
                  <Fragment>
                    <App />
                    <GlobalStyle />
                  </Fragment>
                </ThemeProvider>
              </VwoContextProvider>
            </AuthContextProvider>
          </SiteSettingsProvider>
        </ScrollToTop>
      </QueryClientProvider>
    </CssVariableProvider>
  </BrowserRouter>
);

const root = createRoot(rootElement);
root.render(loadDOM());
